import React, { useMemo } from 'react'
import axios from 'axios'
import { useSelector, useDispatch } from 'react-redux'
import { InputGroup, Input, InputGroupAddon, Button, Row, Col } from 'reactstrap'

import { EXECUTIVE, TRAILER_LEASING, TRUCK_SALES } from '../../constants/divisions'
import { LEAD_STATUS, PENDING_STATUS, PROSPECT_STATUS } from '../../constants/statuses'
import { COMPANY_DRIVER, OWNER_OPERATOR, CONTRACTOR } from '../../constants/entityTypes'
import { TRUCK_SALES_DEALER } from '../../constants/contactCategory'
import { NO_ANSWER_CB_2_HOURS } from '../../constants/nextStep'
import { setDeadToMe, setNotQualifiedToMe, openIGiveUp, getContact } from '../Contacts/redux/ContactActions'
import { editTaskData, getContactName } from './Redux/taskActions'
import { setModal } from '../../common/GlobalModal/redux/GlobalModalActions'
import { notificationDanger } from '../../utils/customToastify'

const ConvertContact = ({ taskStatus, dashComplete }) => {
  const dispatch = useDispatch()
  const { contactData, isExecutive, isAccount, contactDivisionData, divisionId } = useSelector((state) => ({
    contactData: state.Task.otherContactData,
    isAccount: state.Task.otherContactData?.statusData?.id === 3,
    isExecutive: state.auth.user.division_id === EXECUTIVE,
    contactDivisionData: state.Task.otherContactData?.contactDivisionData,
    divisionId: state.auth.user.division_id,
  }))

  // Isto pravilo kao u ContactHeader-u i ConvertingContacts modalu: TS kupci se
  // konvertuju automatski po zatvaranju kvote, dealeri iskljucivo rucno.
  const preventConversionProspectToAccount = useMemo(() => {
    if (
      contactDivisionData?.statusId === PROSPECT_STATUS &&
      divisionId === TRUCK_SALES &&
      contactData?.contactCategory !== TRUCK_SALES_DEALER
    ) {
      return true
    }
    return false
  }, [contactDivisionData, divisionId, contactData])

  const handleConvertClick = async () => {
    const { statusId } = contactDivisionData
    let modalTitle = 'Prospect'

    if (LEAD_STATUS === statusId) {
      modalTitle = 'Lead'
      const response = await axios(`/contacts/isContactActivity/${contactData.id}`)
      if (response.data === false) {
        notificationDanger("You don't have activity for this contact")
        return
      }
    }

    const isLessee =
      [COMPANY_DRIVER, OWNER_OPERATOR, CONTRACTOR].some((item) => item === contactData?.organizationTypeId) &&
      contactDivisionData.statusId === PROSPECT_STATUS
    if (isLessee)
      dispatch(
        setModal({
          id: 'converting_contacts_lessee',
          name: `Convert Prospect`,
        })
      )
    else
      dispatch(
        setModal({
          id: 'converting_contacts',
          name: `Convert ${modalTitle}`,
          props: {
            divisions: contactDivisionData,
            contactId: contactData?.id,
            contact: contactData,
            dashComplete,
            loadData: async () => {
              await dispatch(getContact(contactData?.id, divisionId))
              await dispatch(getContactName(contactData?.id))
            },
          },
        })
      )
  }

  const statusText = (statusData) => {
    return divisionId === TRAILER_LEASING && statusData?.id === PENDING_STATUS ? 'Inactive Account' : statusData?.name
  }

  return (
    <Row>
      <Col md='7'>
        <InputGroup size='sm'>
          <Input value={statusText(contactData?.statusData)} />
          <InputGroupAddon addonType='append'>
            <Button
              onClick={handleConvertClick}
              disabled={isExecutive || isAccount || preventConversionProspectToAccount}
              size='sm'
              color='danger'
            >
              Convert
            </Button>
            <Button
              onClick={async () => {
                await dispatch(getContact(contactData?.id, divisionId))
                await dispatch(setDeadToMe())
                await dispatch(getContactName(contactData?.id))
              }}
              disabled={isExecutive || isAccount}
              size='sm'
              color='secondary'
            >
              Dead
            </Button>
            <Button
              onClick={async () => {
                await dispatch(getContact(contactData?.id, divisionId))
                await dispatch(setNotQualifiedToMe())
                await dispatch(getContactName(contactData?.id))
              }}
              disabled={isExecutive || isAccount}
              size='sm'
              color='success'
            >
              NQ
            </Button>
            <Button
              onClick={async () => {
                await dispatch(getContact(contactData?.id, divisionId))
                await dispatch(openIGiveUp())
                await dispatch(getContactName(contactData?.id))
              }}
              disabled={isExecutive || isAccount}
              size='sm'
              color='info'
            >
              Give Up
            </Button>
            <Button
              onClick={() => dispatch(editTaskData('nextStepId', NO_ANSWER_CB_2_HOURS))}
              disabled={isExecutive || isAccount}
              size='sm'
              color='primary'
            >
              No Answer
            </Button>
          </InputGroupAddon>
        </InputGroup>
      </Col>
      <Col>{taskStatus === 2 && <h3 className='text-danger'>This task is completed</h3>}</Col>
    </Row>
  )
}

export default ConvertContact
